import { useEntitlements } from "./useEntitlements";

/**
 * Whether the account holds the `admin_center.managed_accounts_enabled`
 * entitlement that managed connections require. Only a plain `true` passes,
 * so a missing key and an in-flight query read as not entitled.
 */
export function useIsManagedConnectionsEntitled() {
  const { entitlements, isLoading } = useEntitlements();

  return {
    isManagedConnectionsEntitled:
      entitlements?.entitlements?.adminCenterManagedAccountsEnabled?.value ===
      true,
    isLoading,
  };
}
